/*
 * Copyright 2018- The Pixie Authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import * as React from 'react';

export const SidebarContext = React.createContext(
  {
    expanded: null,
    setExpanded: null,
    selected: null,
    setSelected: null,
    firstRun: null,
    setFirstRun: null,
  },
);
export default function SidebarProvider({ children }) {
  const [expanded, _setExpanded] = React.useState([]);
  const [selected, setSelected] = React.useState([]);
  const [firstRun, setFirstRun] = React.useState(true);
  const setExpanded = (nodeIds) => {
    _setExpanded([...new Set(nodeIds)]);
  };

  return (
    <SidebarContext.Provider
      value={{
        expanded, setExpanded, selected, setSelected, firstRun, setFirstRun,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
}
